import React from 'react';
import { compact } from 'lodash';
import PropertyPrice from '../property_price';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSign } from '@fortawesome/pro-solid-svg-icons';
import { Col, Row } from 'react-bootstrap-5';
import ResultCardHighlights from './result_card_highlights';
import ScoreBadges from './score_badges';
import type { InsightsProperty } from 'bundles/connect/types';

type OffMarketSummaryProps = {
  property: InsightsProperty;
}

export default function OffMarketSummary({ property }: OffMarketSummaryProps) {
  const highlightText = property.highlights
    .map(({ label, value }) => compact([value, label]).join(' '));

  const estimate = property?.valuation?.estimate;
  const salePrice = property?.listings?.salePrice;
  const forSale = !!property?.listings?.forSale;
  const hasPrice = !!((estimate && estimate > 0) || (forSale && salePrice && salePrice > 0));

  return (
    <div className="d-flex flex-column justify-content-md-between gap-3 gap-md-2 h-100">
      {hasPrice && (
        <div>
          <div>
            {forSale && (
              <Col className="text-primary text-xs" xs="auto">
                <FontAwesomeIcon className="me-1" icon={faSign} />
                On Market
              </Col>
            )}
          </div>
          <div className="d-flex flex-column gap-1 clickable-text">
            <Row>
              <Col>
                <PropertyPrice
                  estimatedValue={property?.valuation?.estimate}
                  listingValue={property?.listings?.salePrice}
                  valueClass="fw-semibold fs-base"
                />
              </Col>
            </Row>
            <div className="result-address">
              <div>{property.address}</div>
              <div className="fs-small">{property.city}, {property.state} {property.zip}</div>
            </div>
          </div>
        </div>
      )}
      {!hasPrice && (
        <div className="clickable-text">
          <div className="fw-semibold result-address">{property.address}</div>
          <div className="fs-small">{property.city}, {property.state} {property.zip}</div>
        </div>
      )}
      <div className="small text-muted lh-sm">
        <ResultCardHighlights highlights={highlightText} />
      </div>
      <ScoreBadges scores={property.scores} />
    </div>
  );
}
